import React from 'react';
import img from '../../../assets/about.jpg'

const AboutUs = () => {
    return (
        <div className='flex md:flex-row flex-col my-20'>
            <div className='md:w-1/2 w-full'>
                <img className='dd:w-2/3 w-full ml-auto rounded-md shadow-lg' src={img} alt=""></img>
            </div>
            <div className='md:w-1/2 w-full ml-auto'>
                <h2 className='text-4xl text-center my-5 font-semibold text-warning'>About Us</h2>
                <p className='md:px-10 px-5 text-lg'>
                You're most likely to find deluxe describing a spa, hotel, car, or house. When any of these things is deluxe, it goes beyond the ordinary to provide a superior, luxurious experience. A deluxe home might have thousands of square feet and an in-ground pool, and a deluxe cruise probably includes a large berth and gourmet food. Deluxe comes from the French de luxe, "of luxury," from the Latin luxe, "excess or abundance.</p>
            </div>
        </div>
    );
};

export default AboutUs;